import { h } from 'preact'
import Phrase from '../../../libs/translationsUtils/phrase'

const ToReply = ({ fromIdeaUrl }: { fromIdeaUrl: string }) => (
  <div>
    <Phrase p='idea.merge.to' m='Control' />
    <br />
    <oembed url={fromIdeaUrl} />
    <br />
    <Phrase p='idea.merge.to.votes' m='Control' />
  </div>
)

export default ToReply
